<h2 mat-dialog-title i18n="@@requestDemoDetailTitle|Детали заявки">Request details</h2>

<mat-dialog-content class="detail-content">
  <div class="summary">
    <div class="summary-item">
      <span class="summary-label" i18n="@@requestDemoDetailStatusLabel|Статус заявки">Status</span>
      <span class="summary-value status-pill">{{ data.statusLabel }}</span>
    </div>
    <div class="summary-item">
      <span class="summary-label" i18n="@@requestDemoDetailCreatedLabel|Дата создания">Created</span>
      <span class="summary-value">{{ data.request.createdAt ? (data.request.createdAt | date:'dd.MM.yyyy HH:mm') : '—' }}</span>
    </div>
    <div class="summary-item">
      <span class="summary-label" i18n="@@requestDemoDetailUpdatedLabel|Дата обновления">Updated</span>
      <span class="summary-value">{{ data.request.updatedAt ? (data.request.updatedAt | date:'dd.MM.yyyy HH:mm') : '—' }}</span>
    </div>
  </div>

  <div class="details-grid">
    <div class="details-row">
      <span class="details-label" i18n="@@requestDemoDetailIdLabel|Идентификатор заявки">Request ID</span>
      <span class="details-value">{{ data.request.id }}</span>
    </div>
    <div class="details-row">
      <span class="details-label" i18n="@@requestDemoDetailFioLabel|ФИО клиента">Full name</span>
      <span class="details-value">{{ data.request.fio }}</span>
    </div>
    <div class="details-row">
      <span class="details-label" i18n="@@requestDemoDetailEmailLabel|Электронная почта">Email</span>
      <span class="details-value">{{ data.request.email }}</span>
    </div>
    <div class="details-row">
      <span class="details-label" i18n="@@requestDemoDetailPhoneLabel|Телефон">Phone</span>
      <span class="details-value">{{ data.request.phone }}</span>
    </div>
    <div class="details-row details-description">
      <span class="details-label" i18n="@@requestDemoDetailDescriptionLabel|Описание">Description</span>
      <span class="details-value">{{ data.request.description || '—' }}</span>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="close()" i18n="@@requestDemoDetailCloseButton|Закрыть окно">Close</button>
</mat-dialog-actions>
